<template>
  <div>
    <div class="row-item" v-for="shop in shopList" :key="shop.id">
      <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
      <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
      <el-select
        :value="valueMap[shop.id]"
        :loading="loading[shop.id] || allLoading"
        value-key="templateId"
        name-key="name"
        clearable
        @visible-change="isShow => visibleSelect(isShow, shop.id)"
        @change="v => selectChange(v, shop.id)"
      >
        <el-option v-for="item in optionsMap[shop.id]" :key="item.templateId" :label="item.name" :value="item"> </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { logisticsList } from '@/servers/prod/center/xhs.js';

import _ from 'lodash';
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      valueMap: {},
      optionsMap: {},
      loading: {},
      allLoading: false,
    };
  },
  watch: {
    shopList: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue?.length && !oldValue?.length) {
          this.fetchAll(newValue)
        }
      },
    },
    value: {
      immediate: true,
      handler(v) {
        this.valueMap = {};
        (v || []).forEach(item => {
          const { shopId, templateId, name } = item || {};
          if (shopId && templateId) {
            this.$set(this.valueMap, shopId, item);
            !name && this.getList(shopId);
          }
        });
      },
    },
  },
  methods: {
    async fetchAll(shopList) {
      this.allLoading = true
      try {
        let fetchArr = [];
        shopList = shopList.filter(item => [2, 3].includes(item.state))
        shopList.forEach(item => {
          fetchArr.push(logisticsList(item.id))
        })
        const optionsMap = {};
        const resAll = await Promise.allSettled(fetchArr)
        let isChange = false
        resAll.forEach((resItem, resIndex) => {
          const shopId = shopList[resIndex].id
          const list = resItem.value?.data?.logisticsPlans?.map(item => {
            return {
              shopId,
              templateId: item.planInfoId,
              name: item.planInfoName,
            };
          })
          optionsMap[shopId] = list
          if (list) {
            if (this.valueMap[shopId]) {
              const findItem = list.find(item => item.templateId === this.valueMap[shopId].templateId);
              if (!findItem) {
                this.valueMap[shopId] = null;
                isChange = true
              } else if (!this.valueMap[shopId].name) {
                this.valueMap[shopId].name = findItem.name;
                isChange = true
              }
            } else {
              this.valueMap[shopId] = list?.[0];
              isChange = true
            }
          }

        })
        isChange &&  this.valueChange();
        this.optionsMap = optionsMap;
      } catch (error) {
        console.log(error)
      }
      this.allLoading = false
    },
    visibleSelect(isShow, shopId) {
      if (!isShow) return;
      if (!this.optionsMap[shopId]?.length) {
        this.getList(shopId);
      }
    },
    selectChange(v, shopId) {
      this.valueMap[shopId] = v;
      this.valueChange();
    },
    valueChange() {
      const valueList = Object.values(this.valueMap).filter(Boolean);
      this.$emit('change', valueList);
    },
    // 获取品牌
    async getList(shopId) {
      try {
        this.$set(this.loading, shopId, true);
        const res = await logisticsList(shopId);
        this.loading[shopId] = false;
        let logisticsPlans = res.data?.logisticsPlans || [];
        const list = logisticsPlans.map(item => {
          return {
            shopId,
            templateId: item.planInfoId,
            name: item.planInfoName,
          };
        });
        if (this.valueMap[shopId]) {
          const findItem = list.find(item => item.templateId === this.valueMap[shopId].templateId);
          if (!findItem) {
            this.valueMap[shopId] = null;
            this.valueChange();
          } else if (!this.valueMap[shopId].name) {
            this.valueMap[shopId].name = findItem.name;
            this.valueChange();
          }
        }

        this.$set(this.optionsMap, shopId, list);
      } catch (error) {
        console.log(error, '-----error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.row-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>